export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/male.6f6a97a.svg";